export const genders = [
  { label: 'Male', checked: false },
  { label: 'Female', checked: false },
];

export const notAplicable = [
  { label: 'None or not applicable', checked: false },
];

export const races = [
  { label: 'White', checked: false },
  { label: 'Black / African-American', checked: false },
  { label: 'American Indian', checked: false },
  { label: 'Alaskan Native', checked: false },
  { label: 'Asian Indian', checked: false },
  { label: 'Cambodian', checked: false },
  { label: 'Chinese', checked: false },
  { label: 'Filipino', checked: false },
  { label: 'Guamanian', checked: false },
  { label: 'Hawaiian', checked: false },
  { label: 'Japanese', checked: false },
  { label: 'Korean', checked: false },
  { label: 'Laotian', checked: false },
  { label: 'Samoan', checked: false },
  { label: 'Vietnamese', checked: false },
  { label: 'Other Asian', checked: false },
  { label: 'Other Race', checked: false },
  { label: 'Mixed Race', checked: false },
];

export const ethnicities = [
  { label: 'Not Hispanic', checked: false },
  { label: 'Mexican / Mexican-American', checked: false },
  { label: 'Cuban', checked: false },
  { label: 'Puerto Rico', checked: false },
  { label: 'Other Hispanic / Latino', checked: false },
];

export const getYesNo = [
  { label: 'Yes', checked: false },
  { label: 'No', checked: false },
];

export const disabilities = [
  { label: 'None', checked: false },
  { label: 'Visual', checked: false },
  { label: 'Hearing', checked: false },
  { label: 'Speech', checked: false },
  { label: 'Mobility', checked: false },
];

export const getSocialSecurityNumberOptions = [
  { label: 'Decline to state', checked: false },
  { label: 'None or not applicable', checked: false },
];

export const clientAdmissionLeftDetails = [
  { label: 'CBP Name', value: '' },
  { label: 'Participant', value: '' },
  { label: 'CDC#', value: '' },
];

export const clientAdmissionRightDetails = [
  { label: 'CBP ID', value: null && '' },
  { label: 'STOP Auth ID', value: null && '' },
  { label: 'Admit Date', value: null && '' },
];

export const referalSource = [
  { label: 'Individual, including self-referal', checked: false },
  { label: 'Alcohol / Drug Abuse Program', checked: false },
  { label: 'Other Health Care Provider', checked: false },
  { label: 'School / Educational', checked: false },
  { label: 'Employer / EAP', checked: false },
  { label: '12 Step mutual Aide', checked: false },
  { label: 'SACPA Court / Probation', checked: false },
  { label: 'SACPA Parole', checked: false },
  { label: 'DUI / DWI', checked: false },
  { label: 'State Drug Court Partnership (DCP)', checked: false },
  { label: 'Comprehensive Drug Court Implementation (CDCI)', checked: false },
  { label: 'Non-SACPA Court / Criminal Justice', checked: false },
  { label: 'Other Community Referal', checked: false },
  { label: 'Dependency Court / Child Protective Services', checked: false },
  { label: 'AB109 / PRCS', checked: false },
];

export const primaryAlcoholProblem = [
  { label: 'Heroine', checked: false },
  { label: 'Alcohol', checked: false },
  { label: 'Barbiturates (Enter Name in ADU-1b)', checked: false },
  {
    label: 'Other Sedatives or Hypnotics (Enter Name in ADU-1b)',
    checked: false,
  },
  { label: 'Methamphetamine', checked: false },
  { label: 'Other Amphetamines (Enter Name in ADU-1b)', checked: false },
  { label: 'Other Stimulants (Enter Name in ADU-1b', checked: false },
  { label: 'Cocaine / Crack', checked: false },
  { label: 'Marijuana / Hashish', checked: false },
  { label: 'PCP', checked: false },
  { label: 'Other Hallucinogens (Enter Name in ADU-1b)', checked: false },
  {
    label: 'Tranquilizers (eg: Benzodiazepine) (Enter Name in ADU-1b)',
    checked: false,
  },
  { label: 'Other Tranquilizers (Enter Name in ADU-1b)', checked: false },
  { label: 'Non-prescription metha done', checked: false },
  { label: 'OxyCodone / OxyContin', checked: false },
  { label: 'Other Opiates or Synthetics', checked: false },
  { label: 'Inhalants (Enter Name in ADU-1b)', checked: false },
  { label: 'Over-the-Counter (Enter Name in ADU-1b)', checked: false },
  { label: 'Ecstasy', checked: false },
  { label: 'Other Club Drugs (Enter Name in ADU-1b)', checked: false },
  { label: 'Other (Enter Name in ADU-1b)', checked: false },
];

export const getNotApplicableYesNo = [
  ...getYesNo,
  { label: 'Not applicable', checked: false },
];

export const transactionTypes = [
  { label: 'Initial Admission', checked: false },
  { label: 'Transfer of Change in Service', checked: false },
];

export const serviceTypes = [
  { label: 'Non-Residental / Outpatient', checked: false },
  {
    label: 'Non-Residental / Outpatient Day Program Intensive',
    checked: false,
  },
  { label: 'Non-Residental / Outpatient Detoxification', checked: false },
  { label: 'Residential Detoxification (Hospital)', checked: false },
  { label: 'Residential (30 days or less)', checked: false },
  { label: 'Residential (31 days or more)', checked: false },
];

export const waitingDays = [
  { label: 'A number between 0 and 999', checked: false },
  { label: `Not sure / don't know`, checked: false },
];

export const drugUsedDays = [
  { label: 'A number between 0 and 30', checked: false },
];

export const firstTimeDrugUsage = [
  { label: 'A number between 5 and 105', checked: false },
];

export const routeOfAdministration = [
  { label: 'Oral', checked: false },
  { label: 'Smoking', checked: false },
  { label: 'Inhalation', checked: false },
  { label: 'Injection (IV or Intramuscular', checked: false },
  { label: 'Other', checked: false },
];

export const secondaryAlcoholProblem = [
  { label: 'None', checked: false },
  { label: 'Heroine', checked: false },
  { label: 'Alcohol', checked: false },
  { label: 'Barbiturates (Enter Name in ADU-5b)', checked: false },
  {
    label: 'Other Sedatives or Hypnotics (Enter Name in ADU-5b)',
    checked: false,
  },
  { label: 'Methamphetamine', checked: false },
  { label: 'Other Amphetamine (Enter Name in ADU-5b)', checked: false },
  { label: 'Other Stimulants (Enter Name in ADU-5b)', checked: false },
  { label: 'Cocaine / Crack', checked: false },
  { label: 'Marijuana / Hashish', checked: false },
  { label: 'PCP', checked: false },
  { label: 'Other Hallucinogens (Enter Name in ADU-5b)', checked: false },
  {
    label: 'Tranquilizers  (eg: Benzodiazepine) (Enter Name in ADU-5b)',
    checked: false,
  },
  { label: 'Other Tranquilizers (Enter Name in ADU-5b)', checked: false },
  { label: 'Non-prescription metha done', checked: false },
  { label: 'OxyCodone / OxyContin', checked: false },
  { label: 'Other Opiates or Synthetics', checked: false },
  { label: 'Inhalants (Enter Name in ADU-5b)', checked: false },
  { label: 'Over-the-Counter (Enter Name in ADU-5b)', checked: false },
  { label: 'Ecstasy', checked: false },
  { label: 'Other Club Drugs (Enter Name in ADU-5b)', checked: false },
  { label: 'Other (Enter Name in ADU-5b)', checked: false },
];

export const alcoholUsedDays = [
  { label: 'A number between 0 and 30', checked: false },
  { label: 'None or not applicable', checked: false },
];

export const employementStatus = [
  { label: 'Employed Full Time (35 hoursor more)', checked: false },
  { label: 'Part Time (less than 35 hours)', checked: false },
  { label: 'Unemployed looking for work', checked: false },
  {
    label: 'Unemployed not in the labor force (not seeking)',
    checked: false,
  },
  { label: 'Not in the labor force (not seeking)', checked: false },
];

export const criminalJusticeStatus = [
  { label: 'Not applicable', checked: false },
  { label: 'Under parole supervision by CDC', checked: false },
  { label: 'On parole from any other jurisdiction', checked: false },
  { label: 'On probation from any jurisdiction', checked: false },
  {
    label:
      'Admitted under other diversion from any court under CA Penal Section 1000',
    checked: false,
  },
  { label: 'Incarcerated', checked: false },
  { label: 'Awaiting trial, changes or sentencing', checked: false },
  { label: 'AB109 / PRCS', checked: false },
];

export const departmentCorrection = [
  { label: `Don't know / not sure.`, checked: false },
  { label: 'None or not applicable', checked: false },
];

export const arrestedDays = [
  { label: `A number between 0 to 99`, checked: false },
];

export const notSureYesNo = [
  { label: 'Yes', checked: false },
  { label: 'No', checked: false },
  { label: `Not sure / don't know`, checked: false },
];

export const getLivingArrangements = [
  { label: 'Homeless', checked: false },
  { label: 'Dependent Living', checked: false },
  { label: 'Independent Living', checked: false },
];

export const getMedicationForTreatment = [
  { label: '1) None', checked: false },
  { label: '2) Methadone', checked: false },
  { label: '3) LAAM', checked: false },
  { label: '4) Buprenorphine (Subutex)', checked: false },
  { label: '5) Buprenorphine (Suboxone)', checked: false },
  { label: '6) Other', checked: false },
];

export const fotpPriorityStatus = [
  {
    label:
      '1) Completed Forever Free and released and enrolled in treatment program.',
    checked: false,
  },
  { label: '2) Any woman paroling from CIW.', checked: false },
  {
    label: '3) Completed Forever Free and goes directly to FOTP facility',
    checked: false,
  },
  { label: 'None of not applicable', checked: false },
];

export const getSexualityDetails = [
  { label: 'Bisexual', checked: false },
  { label: 'Declined to state', checked: false },
  { label: 'Gay (Male)', checked: false },
  { label: 'Heterosexual / Strait', checked: false },
  { label: 'Lesbian (Female)', checked: false },
  { label: 'Transgender', checked: false },
  { label: 'Unsure / Questioning', checked: false },
];

export const dischargeStatus = [
  { label: 'Completed Treatment / Referred', checked: false },
  { label: 'Completed Treatment / Not Referred', checked: false },
  {
    label: 'Left Before Completion w / Satisfactory Progress / Standard',
    checked: false,
  },
  {
    label: 'Left Before Completion w / Satisfactory Progress / Administrative',
    checked: false,
  },
  {
    label: 'Left Before Completion w / Unsatisfactory Progress / Standard',
    checked: false,
  },
  {
    label:
      'Left Before Completion w / Unsatisfactory Progress / Administrative',
    checked: false,
  },
  { label: 'Death', checked: false },
  { label: 'Incarceration', checked: false },
];

export const clientDischargeLeftDetails = ({ cboName, prtKey, epdIcnCDC }) => [
  {
    label: 'CBP Name',
    value: cboName,
  },
  { label: 'Participant', value: prtKey },
  { label: 'CDC#', value: epdIcnCDC },
];

export const clientDischargeRightDetails = ({
  cboID,
  cdSapAthID,
  dischargeDate,
}) => [
  {
    label: 'CBP ID',
    value: cboID,
  },
  { label: 'STOP Auth ID', value: cdSapAthID },
  { label: 'Discharge Date', value: dischargeDate },
];
